import React from "react";

import { OnCompleteOutput } from "components/ModalWizard/ModalWizard";
import PricesTable from "components/PageDashboard/PricesTable";
import { SessionType } from "types-and-validators/SessionType";
import { SingleSessionPrice } from "types-and-validators/SingleSessionPrice";
import { Params as SubmitEditableTableChangesParams } from "api/makeApiRequestType/makeSubmitEditableTableChanges";

type SingleSessionPriceWithSessionType = SingleSessionPrice & SessionType;

type OnEdit = (
	arg: SubmitEditableTableChangesParams<
		SingleSessionPriceWithSessionType
	>["rows"]
) => OnCompleteOutput;

interface SingleSessionPricesTableProps {
	singleSessionPricesWithSessionTypes: SingleSessionPriceWithSessionType[];
	isLoading: boolean;
	isWaiting: boolean;
	isError: boolean;
	waitModalTitle: string;
	waitModalIsShowing: boolean;
	onEdit: OnEdit;
}

export type DataInAnyRow = SingleSessionPriceWithSessionType;

const SingleSessionPricesTable: React.FunctionComponent<
	SingleSessionPricesTableProps
> = ({
	singleSessionPricesWithSessionTypes,
	isLoading,
	isWaiting,
	isError,
	onEdit,
	waitModalTitle,
	waitModalIsShowing
}) => {
	return (
		<PricesTable
			pricesWithSessionTypes={singleSessionPricesWithSessionTypes}
			isLoading={isLoading}
			isWaiting={isWaiting}
			isError={isError}
			onEdit={onEdit}
			waitModalTitle={waitModalTitle}
			waitModalIsShowing={waitModalIsShowing}
		/>
	);
};

export default SingleSessionPricesTable;
